/**
 * Contract of the website's public maintenance endpoint
 * `GET /api/v1/maintenance/client-area` (see website
 * `App\Http\Controllers\Api\V1\MaintenanceController`). Maintenances are
 * scheduled from the admin portal; each section carries the text already
 * rendered with the period placeholders replaced.
 */
export type MaintenanceSectionKey = 'all' | 'medical_record' | 'appointments';

/** `active` = in progress · `scheduled` = upcoming · `inactive` = nothing planned */
export type MaintenanceSectionStatus = 'inactive' | 'scheduled' | 'active';

export interface MaintenanceSection {
  active: boolean;
  status: MaintenanceSectionStatus;
  /** ISO 8601 with the site's offset (Europe/Bucharest); null when inactive */
  starts_at: string | null;
  ends_at: string | null;
  /** User-facing text, only for scheduled/active */
  message: string | null;
}

export interface MaintenanceStatus {
  app: string;
  now: string;
  in_maintenance: boolean;
  sections: Partial<Record<MaintenanceSectionKey, MaintenanceSection>>;
}

export const INACTIVE_SECTION: MaintenanceSection = {
  active: false,
  status: 'inactive',
  starts_at: null,
  ends_at: null,
  message: null,
};
